<script lang="ts" setup>
  import type { TypeGroupBookingChopeComponent } from '~/types/contentful'

  defineProps<{
    data: TypeGroupBookingChopeComponent<'WITHOUT_UNRESOLVABLE_LINKS', string>
  }>()
</script>

<template>
  <section class="m-group-booking-chope module-paddings">
    <CGroupBookingChope
      :background-color="data.fields.base?.fields.backgroundColour"
      class="m-group-booking-chope__group-booking-chope"
    />
  </section>
</template>

<style lang="scss" scoped>
  .m-group-booking-chope {
    background-color: v-bind('data.fields.base?.fields.backgroundColour');

    .m-group-booking-chope__group-booking-chope {
      margin: 0 auto;

      padding: 32px 0;

      @include screenMdAndUp {
        padding: 64px 0;
      }

      @include screenLgAndUp {
        padding: 80px 0;
      }
    }
  }
</style>
